<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-form-item label="Marketing Budget">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
            :min=0
            v-decorator="['anggaran_marketing', {initialValue: initialData.anggaran_marketing}]"
          />
        </a-form-item>
        <a-form-item label="Production Budget">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
            :min=0
            v-decorator="['anggaran_produksi', {initialValue: initialData.anggaran_produksi}]"
          />
        </a-form-item>
        <a-form-item label="Implementation Budget">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
            :min=0
            v-decorator="['anggaran_implementasi', {initialValue: initialData.anggaran_implementasi}]"
          />
        </a-form-item>
        <a-form-item label="GA budget">
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
            :min=0
            v-decorator="['anggaran_ga', {initialValue: initialData.anggaran_ga}]"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
export default {
  name: "rab",
  props: {
    data: {},
    mode: "",
  },
  data() {
    return {};
  },
  computed: {
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          anggaran_marketing: null,
          anggaran_produksi: null,
          anggaran_implementasi: null,
          anggaran_ga: null
        };
      } else {
        return {
          anggaran_marketing: this.data.anggaran_marketing,
          anggaran_produksi: this.data.anggaran_produksi,
          anggaran_implementasi: this.data.anggaran_implementasi,
          anggaran_ga: this.data.anggaran_ga
        };
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("projectrab", values);
      });
    }
  }
};
</script>

<style>
</style>